import React from 'react'
import faceImage from '../pages/assets/aboutme/face.jpg'

const PhotoSection: React.FC = () => {
  return (
    <div className="photo-section">
      <div className="photo-container">
        <img
          src={faceImage}
          alt="Omar MDV"
          className="profile-image"
        />
      </div>
    </div>
  )
}

export default PhotoSection